export default "__VITE_ASSET__7rCf5maL__"